import {FETCH_EXPERIENCE_REQUEST, FETCH_EXPERIENCE_SUCCES, FETCH_EXPERIENCE_ERROR} from '../constants/Experience'
import { jsonGet, errorHandler } from '../utils/Request';
import getFilterParameters from '../utils/getFilterParameters';

const loadExperience = (filter) => (dispatch) => {
  const parameters = getFilterParameters(filter, 'experience');
  const apiUrl = `/personal/experience/list/${parameters ? parameters : '' }`;
  dispatch({
    type: FETCH_EXPERIENCE_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      dispatch({
        type: FETCH_EXPERIENCE_SUCCES,
        payload: json,
      });
    })
    .catch((e) => {
      dispatch({
        type: FETCH_EXPERIENCE_ERROR
      });
      errorHandler(e);
    });
};

export { loadExperience };



// WEBPACK FOOTER //
// ./src/actions/ExperienceActions.js